export default "__VITE_ASSET__C2G9aY9y__"